import { render, staticRenderFns } from "./additionalData.vue?vue&type=template&id=9faad42e&scoped=true"
import script from "./additionalData.vue?vue&type=script&lang=js"
export * from "./additionalData.vue?vue&type=script&lang=js"
import style0 from "./additionalData.vue?vue&type=style&index=0&id=9faad42e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faad42e",
  null
  
)

export default component.exports